import { render, staticRenderFns } from "./MbAttestatoView.vue?vue&type=template&id=e0f04f12&scoped=true&"
import script from "./MbAttestatoView.vue?vue&type=script&lang=js&"
export * from "./MbAttestatoView.vue?vue&type=script&lang=js&"
import style0 from "./MbAttestatoView.vue?vue&type=style&index=0&id=e0f04f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f04f12",
  null
  
)

export default component.exports